import React from "react";

interface VisibilitySummaryProps {
    totalVisible: number;
    regionNames: string[];
    entityName: string;
}

export const VisibilitySummary: React.FC<VisibilitySummaryProps> = props => {
    const { totalVisible, regionNames, entityName } = props;

    if (totalVisible === 0) {
        return (
            <div className="px-3 py-2 border-t border-yellow-200 bg-yellow-50">
                <div className="text-sm font-medium text-yellow-800">
                    No offices selected
                </div>
                <div className="text-xs text-yellow-600 mt-1">
                    At least one office must be selected.
                </div>
            </div>
        );
    }

    return (
        <div className="px-3 py-2 border-t border-gray-200 bg-gray-50">
            <div className="text-xs text-gray-500 mt-1">
                {totalVisible == 1 ? (
                    <span>1 office has access to this {entityName}</span>
                ) : (
                    <span>
                        {totalVisible} offices have access to this {entityName}
                    </span>
                )}
            </div>
            <div className="text-xs text-gray-500 mt-1">{regionNames.join(", ")}</div>
        </div>
    );
};
